export const PAPER_LANGUAGES = ["English", "Tamil", "Urdu"]